import moment from "moment";
import _ from "lodash";
import MaxCharacterObject from "MaxCharacterObject";

// Using this flag we will seperate the eventify and koachify features.
// export const DEVELOPMENT_TYPE = "koachify";
export const DEVELOPMENT_TYPE = "eventify";

// ========= New Prod (hub) ============ //
export var MAIN_URL = "https://hub.eventify.io"; // Prod
export var INSTANCE_URL = "https://api3.eventify.io"; // Prod
export var DOMAIN_NAME =
  DEVELOPMENT_TYPE === "koachify" ? "koachify.io" : "eventify.io";

// Stripe
export var STRIPE_PUBLISHABLE_KEY = "pk_live_VZSpPMDkLza88TRanKPF0xMU"; // Live
export const STRIPE_CLIENTID = "ca_FHZmcGRhYTWD3w1XasrY36koIRCCV7OO"; // Live
export const STRIPE_CALLBACK_URI =
  "https://star.eventify.io/t/stripe/callback.php"; // Live

// Eventbrite
export var EVENTBRITE_API_KEY = "SIJFQPCQTSAL7HHYUO";
export var EVENTBRITE_SECRET_KEY =
  "DO7P5PIELZEICMQYXPZE6KHOBHTTFA53TB5QZRAXUJEXIH72AP";

// ========= Dev ============ //
// export var MAIN_URL =
//   DEVELOPMENT_TYPE === "eventify"
//     ? "https://dev.eventify.io"
//     : "https://kdev.eventify.io"; // Dev
// export var INSTANCE_URL = "https://devapi.eventify.io"; // Dev
// export var DOMAIN_NAME =
//   DEVELOPMENT_TYPE === "koachify" ? "koachify.io" : "dev.eventify.io";

// // Stripe
// export var STRIPE_PUBLISHABLE_KEY = "pk_test_mYqHtpyz7nX68JwESQs6bMQ8"; // Test
// export var STRIPE_SECRET_KEY = "sk_test_QGxZXg6tB3T2hsxkUDV762Wi"; // Test
// export const STRIPE_CLIENTID = "ca_FHZmJN9uD8yzTD2iI25j0RgqcKvJbUYl"; // Test
// export const STRIPE_CALLBACK_URI =
//   "https://star.dev.eventify.io/t/stripe/callback.php"; // Test

// // Eventbrite
// export var EVENTBRITE_API_KEY = "WX6D26UB7HCR767FXA"; // Test
// export var EVENTBRITE_SECRET_KEY =
//   "OXNPY3HJDAC7MBBYAV7MQ4DFQGITSQLUBKIOOWDYRJY5BDBO6H"; // Test

// Others
export var BASE_IMAGES_URL = `${INSTANCE_URL}/api/v2/files`;
export var BASE_IMAGES_LOCAL_URL = `${INSTANCE_URL}/api/v2/files3`;
export var BASE_INLINE_UPLOAD_BASE_URL = `${INSTANCE_URL}/eventifyscripts/uploadinline.php`; // 'http://app.eventify.io:83/eventifyscripts/uploadinline.php';
export var BASE_INLINE_IMAGE_URL =
  "http://staging.teks.co.in/eventify/eventifyscripts/";
export var GRAPESJE_EDITOR = `${MAIN_URL}/newsletter-new/index.php`;
// export var GRAPESJE_EDITOR = 'https://staging.teks.co.in/udayan/newsletter-new/index.php';
export var TUTORIAL_VIDEO_URL = `${INSTANCE_URL}/api/v2/files/eventify/tutorialvids/`;

/***** SOCIAL FEED *****/
export var INSTAGRAM_CLIENT_SECRET = "2d2e7dc7dd597c33c121838b8cb6f7a5"; // instagram client secret;
export var INSTAGRAM_CLIENTID = 632574764506776; // instagram client ID;

export var IMAGE_PATH = "../../style/images/";
export var NEW_IMAGE_PATH = "../../style/images/v2_icons/";

export var APP_API_KEY =
  "c26f1a65cc24c851ed1d2ebb69eb2d64686823891ca0408dae59fb58b6844293";
export var UPLOAD_FILES_API_KEY = APP_API_KEY;
export var ACCESS_FILES_API_KEY = APP_API_KEY;
export var ONE_SIGNAL_KEY = "OTBmOGQzYWItNGEzOS00YjI0LWIyZDQtZjZjMTZiYjg0MDJj";
export var ONE_SIGNAL_ID = "5f63255c-7a1c-4d93-acd0-c76d599374aa";
export var GOOGLE_MAP_KEY = "AIzaSyD43ZsO29SstAuHzztQzx_EGCY1t50SPF8";

export var LOGIN = "LOGIN";
export var REGISTER = "REGISTER";
export var SELECT_APP_ICON = "SELECTAPPICON";
export var UPDATE_UNSAVED_STATUS = "UPDATE_UNSAVED_STATUS";
export var SELECT_FEATURE = "select_feature";
export var SELECTED_CONTENT_FEATURE = "SELECTED_CONTENT_FEATURE";
export var CHANGE_PASSWORD = "CHANGE_PASSWORD";
export var EDIT_CONTENT_ICON_NAME = "EDIT_CONTENT_ICON_NAME";
export var UPDATE_FILES_UPLOAD_PROGRESS = "UPDATE_FILES_UPLOAD_PROGRESS";
export var FILES_UPLOAD_FAILED = "FILES_UPLOAD_FAILED";
export var FILES_UPLOADED = "FILES_UPLOADED";
export var CONTENT_FILE_TYPE_EVENTGUIDE = "eventguidefile";
export var CONTENT_FILE_TYPE_SPEAKER = "speakerfile";
export var CONTENT_FILE_TYPE_SPONSOR = "sponsorfile";
export var CONTENT_FILE_TYPE_EXHIBITOR = "exhibitorfile";
export var TO_CHANGE_EMAIL = "TO_CHANGE_EMAIL";
export var COMMON_FAIL_MESSAGE = "Something went wrong!!";
export var ATTACHEMNT_REQUIRED_MESSAGE = "Attachment Required!!";

export const EVENTIFY_FEE = 1.0; // amount
export const STRIPE_FEE = 2.9;
export const STRIPE_FEE_EXTRA = 0.3;
export var MAX_INTEREST_COUNT = 50;
export var DATE_FORMAT = "YYYY-MM-DD";
export var DATE_FORMAT_FNS = "yyyy-MM-dd";
export var DATE_FORMAT_WITH_TIME = "YYYY-MM-DD HH:mm";
export var DATE_FORMAT_WITH_TIME_FNS = "yyyy-MM-dd HH:mm";
export var DATE_FORMAT_WITH_TIME_WITH_SECOND = "YYYY-MM-DD HH:mm:ss";
export const isMobile = window.innerWidth <= 500;
export const screenHeightLeftFromTop = 142;

export var HIGHEND_PASSWORD = "uB9*#R!z";
export const GarbageKey = "A8d36@hfD92W7!";

export var itemCount = calculateItemCount();
export var DISPLAY_DATE_FORMAT = getLocaleShortDateString();
export var DISPLAY_LOCAL_DATE_FORMAT = localeDateFormat();
export const isTablet = determineIfTablet();

function determineIfTablet() {
  var width = window.innerWidth;
  var height = window.innerHeight;

  var istablet = false;

  if (
    (width === 1366 && height === 1024) ||
    (height === 1365 && width === 1024)
  ) {
    //Check for iPad Pro
    istablet = true;
  } else if (
    (width === 1024 && height === 768) ||
    (height === 768 && width === 1024)
  ) {
    //Check for iPad
    istablet = true;
  }
  return istablet;
}
/***** Class Join Function *****/
export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function calculateItemCount() {
  //dynamically calcualting number of items to show as per height of the screen
  var height = window.innerHeight - 250; //250 is calculated to deduct extra space used other than just table
  var maxrowheight = 50;

  var count = Math.ceil(height / maxrowheight);

  /*if(height<700){
    count=2;
  }else if(height>700){
    count=15;
  }*/

  return count < 1 ? 1 : count;
}

export function timeAgo(dateParam) {
  let now = moment();
  let then = moment.utc(dateParam);
  then = then.local();

  let diff = {};
  diff.unit = "just now";
  diff.value = now.diff(then, "seconds");

  if (diff.value > 1) {
    diff.unit = "secs";
  }

  if (diff.unit === "secs" && diff.value > 59) {
    diff.unit = "min";
    diff.value = now.diff(then, "minutes");

    if (diff.value > 1) {
      diff.unit = "mins";
    }
  }
  if (diff.unit === "mins" && diff.value > 59) {
    diff.unit = "hour";
    diff.value = now.diff(then, "hours");

    if (diff.value > 1) {
      diff.unit = "hours";
    }
  }
  if (diff.unit === "hours" && diff.value > 24) {
    diff.unit = "day";
    diff.value = now.diff(then, "days");

    if (diff.value > 1) {
      diff.unit = "days";
    }
  }
  if (diff.unit === "days" && diff.value > 7) {
    diff.unit = "week";
    diff.value = now.diff(then, "weeks");

    if (diff.value > 1) {
      diff.unit = "weeks";
    }
  }
  if (diff.unit === "weeks" && diff.value > 4) {
    diff.unit = "month";
    diff.value = now.diff(then, "months");

    if (diff.value > 1) {
      diff.unit = "months";
    }
  }
  if (diff.unit === "months" && diff.value > 12) {
    diff.unit = "year";
    diff.value = now.diff(then, "years");

    if (diff.value > 1) {
      diff.unit = "years";
    }
  }
  return diff.unit !== "just now"
    ? diff.value + " " + diff.unit + " ago"
    : diff.unit;
}

export var isJSON = (str) => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

export const MIN_DATE = new Date(1992, 0, 7);
export const MAX_DATE = new Date(2100, 0, 1);

function getLocaleShortDateString() {
  let date = new Date(1992, 0, 7);
  let f = {
    "ar-SA": "dd/MM/yy",
    "bg-BG": "dd.M.yyyy",
    "ca-ES": "dd/MM/yyyy",
    "zh-TW": "yyyy/M/d",
    "cs-CZ": "d.M.yyyy",
    "da-DK": "dd-MM-yyyy",
    "de-DE": "dd.MM.yyyy",
    "el-GR": "d/M/yyyy",
    "en-US": "M/d/yyyy",
    "fi-FI": "d.M.yyyy",
    "fr-FR": "dd/MM/yyyy",
    "he-IL": "dd/MM/yyyy",
    "hu-HU": "yyyy. MM. dd.",
    "is-IS": "d.M.yyyy",
    "it-IT": "dd/MM/yyyy",
    "ja-JP": "yyyy/MM/dd",
    "ko-KR": "yyyy-MM-dd",
    "nl-NL": "d-M-yyyy",
    "nb-NO": "dd.MM.yyyy",
    "pl-PL": "yyyy-MM-dd",
    "pt-BR": "d/M/yyyy",
    "ro-RO": "dd.MM.yyyy",
    "ru-RU": "dd.MM.yyyy",
    "hr-HR": "d.M.yyyy",
    "sk-SK": "d. M. yyyy",
    "sq-AL": "yyyy-MM-dd",
    "sv-SE": "yyyy-MM-dd",
    "th-TH": "d/M/yyyy",
    "tr-TR": "dd.MM.yyyy",
    "ur-PK": "dd/MM/yyyy",
    "id-ID": "dd/MM/yyyy",
    "uk-UA": "dd.MM.yyyy",
    "be-BY": "dd.MM.yyyy",
    "sl-SI": "d.M.yyyy",
    "et-EE": "d.MM.yyyy",
    "lv-LV": "yyyy.MM.dd.",
    "lt-LT": "yyyy.MM.dd",
    "fa-IR": "MM/dd/yyyy",
    "vi-VN": "dd/MM/yyyy",
    "hy-AM": "dd.MM.yyyy",
    "az-Latn-AZ": "dd.MM.yyyy",
    "eu-ES": "yyyy/MM/dd",
    "mk-MK": "dd.MM.yyyy",
    "af-ZA": "yyyy/MM/dd",
    "ka-GE": "dd.MM.yyyy",
    "fo-FO": "dd-MM-yyyy",
    "hi-IN": "dd-MM-yyyy",
    "ms-MY": "dd/MM/yyyy",
    "kk-KZ": "dd.MM.yyyy",
    "ky-KG": "dd.MM.yy",
    "sw-KE": "M/d/yyyy",
    "uz-Latn-UZ": "dd/MM yyyy",
    "tt-RU": "dd.MM.yyyy",
    "pa-IN": "dd-MM-yy",
    "gu-IN": "dd-MM-yy",
    "ta-IN": "dd-MM-yyyy",
    "te-IN": "dd-MM-yy",
    "kn-IN": "dd-MM-yy",
    "mr-IN": "dd-MM-yyyy",
    "sa-IN": "dd-MM-yyyy",
    "mn-MN": "yy.MM.dd",
    "gl-ES": "dd/MM/yy",
    "kok-IN": "dd-MM-yyyy",
    "syr-SY": "dd/MM/yyyy",
    "dv-MV": "dd/MM/yy",
    "ar-IQ": "dd/MM/yyyy",
    "zh-CN": "yyyy/M/d",
    "de-CH": "dd.MM.yyyy",
    "en-GB": "dd/MM/yyyy",
    "es-MX": "dd/MM/yyyy",
    "fr-BE": "d/MM/yyyy",
    "it-CH": "dd.MM.yyyy",
    "nl-BE": "d/MM/yyyy",
    "nn-NO": "dd.MM.yyyy",
    "pt-PT": "dd-MM-yyyy",
    "sr-Latn-CS": "d.M.yyyy",
    "sv-FI": "d.M.yyyy",
    "az-Cyrl-AZ": "dd.MM.yyyy",
    "ms-BN": "dd/MM/yyyy",
    "uz-Cyrl-UZ": "dd.MM.yyyy",
    "ar-EG": "dd/MM/yyyy",
    "zh-HK": "d/M/yyyy",
    "de-AT": "dd.MM.yyyy",
    "en-AU": "d/MM/yyyy",
    "es-ES": "dd/MM/yyyy",
    "fr-CA": "yyyy-MM-dd",
    "sr-Cyrl-CS": "d.M.yyyy",
    "ar-LY": "dd/MM/yyyy",
    "zh-SG": "d/M/yyyy",
    "de-LU": "dd.MM.yyyy",
    "en-CA": "dd/MM/yyyy",
    "es-GT": "dd/MM/yyyy",
    "fr-CH": "dd.MM.yyyy",
    "ar-DZ": "dd-MM-yyyy",
    "zh-MO": "d/M/yyyy",
    "de-LI": "dd.MM.yyyy",
    "en-NZ": "d/MM/yyyy",
    "es-CR": "dd/MM/yyyy",
    "fr-LU": "dd/MM/yyyy",
    "ar-MA": "dd-MM-yyyy",
    "en-IE": "dd/MM/yyyy",
    "es-PA": "MM/dd/yyyy",
    "fr-MC": "dd/MM/yyyy",
    "ar-TN": "dd-MM-yyyy",
    "en-ZA": "yyyy/MM/dd",
    "es-DO": "dd/MM/yyyy",
    "ar-OM": "dd/MM/yyyy",
    "en-JM": "dd/MM/yyyy",
    "es-VE": "dd/MM/yyyy",
    "ar-YE": "dd/MM/yyyy",
    "en-029": "MM/dd/yyyy",
    "es-CO": "dd/MM/yyyy",
    "ar-SY": "dd/MM/yyyy",
    "en-BZ": "dd/MM/yyyy",
    "es-PE": "dd/MM/yyyy",
    "ar-JO": "dd/MM/yyyy",
    "en-TT": "dd/MM/yyyy",
    "es-AR": "dd/MM/yyyy",
    "ar-LB": "dd/MM/yyyy",
    "en-ZW": "M/d/yyyy",
    "es-EC": "dd/MM/yyyy",
    "ar-KW": "dd/MM/yyyy",
    "en-PH": "M/d/yyyy",
    "es-CL": "dd-MM-yyyy",
    "ar-AE": "dd/MM/yyyy",
    "es-UY": "dd/MM/yyyy",
    "ar-BH": "dd/MM/yyyy",
    "es-PY": "dd/MM/yyyy",
    "ar-QA": "dd/MM/yyyy",
    "es-BO": "dd/MM/yyyy",
    "es-SV": "dd/MM/yyyy",
    "es-HN": "dd/MM/yyyy",
    "es-NI": "dd/MM/yyyy",
    "es-PR": "dd/MM/yyyy",
    "am-ET": "d/M/yyyy",
    "tzm-Latn-DZ": "dd-MM-yyyy",
    "iu-Latn-CA": "d/MM/yyyy",
    "sma-NO": "dd.MM.yyyy",
    "mn-Mong-CN": "yyyy/M/d",
    "gd-GB": "dd/MM/yyyy",
    "en-MY": "d/M/yyyy",
    "prs-AF": "dd/MM/yy",
    "bn-BD": "dd-MM-yy",
    "wo-SN": "dd/MM/yyyy",
    "rw-RW": "M/d/yyyy",
    "qut-GT": "dd/MM/yyyy",
    "sah-RU": "MM.dd.yyyy",
    "gsw-FR": "dd/MM/yyyy",
    "co-FR": "dd/MM/yyyy",
    "oc-FR": "dd/MM/yyyy",
    "mi-NZ": "dd/MM/yyyy",
    "ga-IE": "dd/MM/yyyy",
    "se-SE": "yyyy-MM-dd",
    "br-FR": "dd/MM/yyyy",
    "smn-FI": "d.M.yyyy",
    "moh-CA": "M/d/yyyy",
    "arn-CL": "dd-MM-yyyy",
    "ii-CN": "yyyy/M/d",
    "dsb-DE": "d. M. yyyy",
    "ig-NG": "d/M/yyyy",
    "kl-GL": "dd-MM-yyyy",
    "lb-LU": "dd/MM/yyyy",
    "ba-RU": "dd.MM.yy",
    "nso-ZA": "yyyy/MM/dd",
    "quz-BO": "dd/MM/yyyy",
    "yo-NG": "d/M/yyyy",
    "ha-Latn-NG": "d/M/yyyy",
    "fil-PH": "M/d/yyyy",
    "ps-AF": "dd/MM/yy",
    "fy-NL": "d-M-yyyy",
    "ne-NP": "M/d/yyyy",
    "se-NO": "dd.MM.yyyy",
    "iu-Cans-CA": "d/M/yyyy",
    "sr-Latn-RS": "d.M.yyyy",
    "si-LK": "yyyy-MM-dd",
    "sr-Cyrl-RS": "d.M.yyyy",
    "lo-LA": "dd/MM/yyyy",
    "km-KH": "yyyy-MM-dd",
    "cy-GB": "dd/MM/yyyy",
    "bo-CN": "yyyy/M/d",
    "sms-FI": "d.M.yyyy",
    "as-IN": "dd-MM-yyyy",
    "ml-IN": "dd-MM-yy",
    "en-IN": "dd-MM-yyyy",
    "or-IN": "dd-MM-yy",
    "bn-IN": "dd-MM-yy",
    "tk-TM": "dd.MM.yy",
    "bs-Latn-BA": "d.M.yyyy",
    "mt-MT": "dd/MM/yyyy",
    "sr-Cyrl-ME": "d.M.yyyy",
    "se-FI": "d.M.yyyy",
    "zu-ZA": "yyyy/MM/dd",
    "xh-ZA": "yyyy/MM/dd",
    "tn-ZA": "yyyy/MM/dd",
    "hsb-DE": "d. M. yyyy",
    "bs-Cyrl-BA": "d.M.yyyy",
    "tg-Cyrl-TJ": "dd.MM.yy",
    "sr-Latn-BA": "d.M.yyyy",
    "smj-NO": "dd.MM.yyyy",
    "rm-CH": "dd/MM/yyyy",
    "smj-SE": "yyyy-MM-dd",
    "quz-EC": "dd/MM/yyyy",
    "quz-PE": "dd/MM/yyyy",
    "hr-BA": "d.M.yyyy.",
    "sr-Latn-ME": "d.M.yyyy",
    "sma-SE": "yyyy-MM-dd",
    "en-SG": "d/M/yyyy",
    "ug-CN": "yyyy-M-d",
    "sr-Cyrl-BA": "d.M.yyyy",
    "es-US": "M/d/yyyy",
  };

  let l = navigator.language ? navigator.language : navigator["userLanguage"],
    y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate();

  f = l in f ? f[l] : "dd/MM/yyyy";
  // f = "dd/MM/yyyy";
  // return f.toUpperCase();
  return f;
}

function localeDateFormat() {
  var local = DISPLAY_DATE_FORMAT.toUpperCase();
  return local;
}

export function converDateIntoLocal(date) {
  var stillUtc = moment.utc(date).toDate();
  // var local = moment(stillUtc).local().format("DD/MM/YYYY HH:mm");
  var local = moment(stillUtc)
    .local()
    .format(`${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`);
  return local;
}

export function converDateIntoLocal1(date) {
  var stillUtc = moment.utc(date).toDate();
  var local = moment(stillUtc).local();
  // .format('YYYY-MM-DD HH:mm:ss');
  return local;
}

export function converDateIntoLocalWithOutFormat(date) {
  var stillUtc = moment.utc(date).toDate();
  return stillUtc;
}

export function converDateIntoLocalDate(date) {
  var stillUtc = moment.utc(date).toDate();
  // var local = moment(stillUtc).local().format("DD/MM/YYYY");
  var local = moment(stillUtc).local().format(DISPLAY_LOCAL_DATE_FORMAT);
  return local;
}

export function converDateIntoUTC(date) {
  // let datetimeUTC = moment.utc(date);
  let date1 = new Date(date);

  let datetimeUTC = moment(date1, "ddd, DD MMM YYYY HH:mm:ss"); // Parse string in local time
  let datetime = datetimeUTC.format("YYYY-MM-DD HH:mm:ss");

  return datetime;
}

export function checkDateFormatYMD(date) {
  // console.log("date :- ", date);
  var regex = new RegExp(/[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/);

  return regex.test(date);
}

export var contentHeight = calculateHeight();

function calculateHeight() {
  if (window.innerHeight < 665) return window.innerHeight + 60;
  else return 0;
  //Old codes else 0;
}

export function validateEmail(email) {
  // var re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  var re = /^\w+([\.'-]?\w+)*@\w+([\.'-]?\w+)*(\.\w{2,10})+$/;
  return re.test(email);
}

export function validateUrl(url) {
  // var re = /^(?:(http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;

  var re =
    /^(?:(?:(?:https?|http):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;

  return re.test(url);
}

export function validateSocialMediaUrl(url) {
  var re =
    /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;

  // "http://example.com",
  // "https://www.example.com",
  // "http://subdomain.example.com",
  // "https://subdomain.example.com",
  // "http://www.subdomain.example.com",
  // "https://www.subdomain.example.com",
  // "http://example.com/path/to/resource",
  // "https://www.example.com/path/to/resource",
  // "http://subdomain.example.com/path/to/resource",
  // "https://subdomain.example.com/path/to/resource",
  // "http://www.subdomain.example.com/path/to/resource",
  // "https://www.subdomain.example.com/path/to/resource",
  // "http://example-domain.com",
  // "http://subdomain.example-domain.com",
  // "http://www.subdomain.example-domain.com",
  // "www.uco.co.in",
  // "http://www.uco.co.in",
  // "https://www.uco.co.in",
  // "https://app.eventify.io/assets/exhibitor_logo.jpg",
  // "http://app.eventify.io/assets/exhibitor_logo.jpg",
  // "www.app.eventify.io/assets/exhibitor_logo.jpg";

  return re.test(url);
}

export function validateOnlyNums(value) {
  // return value.replace(/[^\d]/g, "");
  // let check = !isNaN(value);
  var re = /^\d+$/;
  var check = re.test(value);

  return check;
}

export function validateDecimalNums(value) {
  // var re = /^[1-9]\d*(\.\d+)?$/;
  var re = /^\s*[+-]?(\d+|\d*\.\d+|\d+\.\d*)([Ee][+-]?\d+)?\s*$/;
  var check = re.test(value);

  return check;
}

export function validatePhoneNumbers(value) {
  let re =
    /^[\+]?[(]?[0-9]{2,5}[)]?[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{2,5}[-\s\.]?[0-9]{4,6}$/im;
  // let re = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/
  return re.test(value);
}

export function validateWhitespace(value) {
  return value === null || value.match(/^ *$/) !== null;
}

export function validateSpecialChar(string) {
  var re = /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g;
  return re.test(string);
}

export function validateAmpersandChar(string) {
  var re = /\&/g;
  return re.test(string);
}

export var dashboardContentWidth = calculatedDashboardContentWidth();

function calculatedDashboardContentWidth() {
  return window.innerWidth - (isTablet ? 0 : 320);
}

export var chartWidth = calculatedChartWidth();

function calculatedChartWidth() {
  return window.innerWidth - 200;
}

export var usersChartWidth = calculatedUsersChartWidth();

function calculatedUsersChartWidth() {
  return window.innerWidth - 400;
}

export var fullDashboardContentWidth = calculatedFullDashboardContentWidth();

function calculatedFullDashboardContentWidth() {
  return window.innerWidth - 5;
}

export var contentContainerWidth = calculatedContentContainerWidth();

function calculatedContentContainerWidth() {
  // return (window.innerWidth-(isTablet?0:320)-275);
  return window.innerWidth - 324;
}

export var ticketsContentContainerWidth =
  calculatedTicketsContentContainerWidth();

function calculatedTicketsContentContainerWidth() {
  return window.innerWidth - 324;
}

export var commonContainerWidth = calculatedCommonContainerWidth();

function calculatedCommonContainerWidth() {
  return window.innerWidth - 325;
}

export var chooserPopupHeight = calculatedChooserPopupHeight();

function calculatedChooserPopupHeight() {
  return window.innerHeight - 150;
}

export var chooserPopupGridHeight = calculatedChooserPopupGridHeight();

function calculatedChooserPopupGridHeight() {
  return window.innerHeight - 170;
}

export var courseContainerWidth = calculatedCourseContainerWidth();
function calculatedCourseContainerWidth() {
  return window.innerWidth - 325;
}

//incomplete code for the scrollable content part of each page

// function innerScrollHeightContent(){
//   return (window.innerHeight-72);
// return (window.innerHeight-142);
// }

// function updateSize() {
//   var isMobile = window.innerWidth > 0 ? false : true;
//   if (isMobile == false) {
//   var width = window.innerWidth;
//   var height = window.innerHeight;
//   setSize([width, height]);
//   props.deviceSize({ width: width, height: height });
//   } else {
//   var width = screen.width;
//   var height = screen.height;
//   setSize([width, height]);
//   props.deviceSize({ width: width, height: height });
//   }
//   }

/*** It WIll Return Filter Array by route  ***/
export function maxLengthObjectFc(history) {
  // console.log("maxLengthObjectFc history", history);
  let patharr = _.slice(
    _.split(history.location.pathname, "/"),
    1,
    _.split(history.location.pathname, "/").length
  );

  let finalObj = null;
  _.forEach(patharr, function (value, key) {
    if (finalObj === null) {
      finalObj = value in MaxCharacterObject ? MaxCharacterObject[value] : {};
    } else {
      finalObj = value in finalObj ? finalObj[value] : {};
    }
  });
  return finalObj;
}

export function converDateIntoLocalwithmonth(date) {
  var stillUtc = moment.utc(date).toDate();
  var local = moment(stillUtc).local();
  // .format('YYYY-MM-DD HH:mm:ss');
  return local;
}
